<form [formGroup]="formGroup" novalidate>
  <div formArrayName="participants">
    <div *ngFor="let t of participants.controls; let i=index" [formGroupName]="i">
      <mat-form-field>
        <input matInput placeholder="Vorname" formControlName="vorname" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Nachname" formControlName="nachname" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Geburtsdatum" [min]="geburtsdatumMin" [max]="geburtsdatumMax"
               formControlName="geburtsdatum" [matDatepicker]="geburtsdatumDatepicker" required>
        <!--<mat-datepicker-toggle matSuffix [for]="geburtsdatumDatepicker"></mat-datepicker-toggle>-->
        <mat-datepicker #geburtsdatumDatepicker startView="year" [startAt]="geburtsdatumInit"></mat-datepicker>
        <mat-hint align="start">für evtl. Jugend Ermäßigung</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Geburtsland" formControlName="geburtsland" autocomplete="country-name" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Nationalität" formControlName="nationalitaet" autocomplete="country-name" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Handy / WhatsApp" formControlName="handy" type="tel" required>
      </mat-form-field>
      <button mat-button color="primary" (click)="removeAt(i)" type="button">entfernen</button>
    </div>
  </div>
  <button mat-button color="primary" (click)="add()" type="button">Teilnehmer hinzufügen</button>
  <div [hidden]="formGroup.valid || formGroup.pristine" class="alert alert-warning">
    Bitte alle erforderlichen Felder (*) ausfüllen!
  </div>
</form>
